import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Techstack from "./Techstack";
import Missioncard, { MissionCarryForwardCard, MissionVibrantCommunityCard } from "./MissionCard";
import laptopImg from "../../Assets/about.jpg";
import syepMain from "../../Assets/syepMain.png";
import cf2025 from "../../Assets/syep_2025.jpeg";
import cfCommunity1 from "../../Assets/cf-community-1.png";
import cfCommunity2 from "../../Assets/cf-community-2.png";
import cfCommunity3 from "../../Assets/cf-community-3.png";
import cfCommunity4 from "../../Assets/cf-community-4.png";
import cfCommunity6 from "../../Assets/cf-community-6.png";
import cfCommunity7 from "../../Assets/cf-community-7.png";
import cfCommunity8 from "../../Assets/cf-community-8.png";
import cfCommunity9 from "../../Assets/cf-community-9.png";
import cfCommunity10 from "../../Assets/cf-community-10.png";

import { Trans, useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SlickLazyImage from "../shared/SlickLazyImage";

function Mission() {
  const { t } = useTranslation();

  const [activeSlide, setActiveSlide] = React.useState(0);

  const sliderImages = [
     { src: cfCommunity1, altKey: "aboutWho.sliderAlts.2" },
     { src: syepMain, altKey: "aboutWho.sliderAlts.0" },
     { src: cfCommunity6, altKey: "aboutWho.sliderAlts.7" },  
     { src: cfCommunity2, altKey: "aboutWho.sliderAlts.3" },
     { src: cfCommunity3, altKey: "aboutWho.sliderAlts.4" },
     { src: cf2025, altKey: "aboutWho.sliderAlts.1" },
     { src: cfCommunity4, altKey: "aboutWho.sliderAlts.5" },
     { src: cfCommunity7, altKey: "aboutWho.sliderAlts.8" },
     { src: cfCommunity8, altKey: "aboutWho.sliderAlts.9" },
     { src: cfCommunity9, altKey: "aboutWho.sliderAlts.10" },
     { src: cfCommunity10, altKey: "aboutWho.sliderAlts.11" },
   ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2400,
    pauseOnHover: true,
    pauseOnFocus: true,
    adaptiveHeight: false,
    lazyLoad: "ondemand",
    beforeChange: (_current, next) => setActiveSlide(next),
  };

  return (
    <Container fluid className="about-section mission-page">
      <Particle />
      <Container className="mission-container">
        <header className="mission-hero">
          <h1 className="mission-hero-title">
            <Trans i18nKey="mission.hero.title" components={{ purple: <strong className="purple" /> }} />
          </h1>
          <p className="mission-hero-lead">
            {t("mission.hero.lead")}
          </p>
        </header>

        <Row className="mission-top about-top">
          <Col xs={12} md={6} className="about-top-col mission-left">
            <Missioncard />
          </Col>

          <Col xs={12} md={6} className="about-top-col mission-right">
            <div
              className="policy-card mission-image-card mission-slider-card mission-top-media-card about-top-media-card"
              aria-label={t("mission.a11y.imageAlt")}
            >
              <Slider {...sliderSettings}>
                {sliderImages.map((image, index) => (
                  <div key={index} className="mission-slide">
                    <SlickLazyImage
                      src={image.src}
                      alt={t(image.altKey)}
                      className="mission-slide-img"
                      index={index}
                      activeIndex={activeSlide}
                      total={sliderImages.length}
                      buffer={2}
                      eager
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>

        <Row className="mission-details" style={{ justifyContent: "center" }}>
          <Col md={6} className="mission-details-col order-2 order-md-1">
            <div className="policy-card mission-image-card">
              <img src={laptopImg} alt={t("mission.a11y.imageAlt")} className="mission-image" />
            </div>
          </Col>

          <Col md={6} className="mission-details-col order-1 order-md-2">
            <MissionCarryForwardCard />
          </Col>
        </Row>

        <Row className="mission-details mission-vibrant-row" style={{ justifyContent: "center" }}>
          <Col md={10} className="mission-details-col">
            <MissionVibrantCommunityCard />
          </Col>
        </Row>

        <h2 className="mission-section-heading">
          <Trans i18nKey="mission.coreValues.heading" components={{ purple: <strong className="purple" /> }} />
        </h2>

        <Techstack />
      </Container>
    </Container>
  );
}

export default Mission;
